import Billing from '@console/components/project/Billing';
import type { AppState } from '@console/reducers';
import { getClaimsGroupedByBillingMonth } from '@console/selectors/projectDetail/claims';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({
  claimsGroupedByBillingMonth: getClaimsGroupedByBillingMonth(state)
});

const mapDispatchToProps = () => ({});

export type BillingPropsMappedFromState = ReturnType<typeof mapStateToProps>;
export type BillingPropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(Billing);
